import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { pickChannelIcon } from './utils';
import useStyles from './useStyles';

const ChannelIcon = ({ className, channel, rounded, meta, monochrome }) => {
  const styles = useStyles();

  const IconClass = useMemo(
    () => pickChannelIcon(channel, rounded, meta),
    [channel, rounded, meta]
  );

  return (
    <IconClass
      className={cx(styles.root, className)}
      monochrome={monochrome}
    />
  );
};

ChannelIcon.propTypes = {
  className: PropTypes.string,
  channel: PropTypes.string.isRequired,
  rounded: PropTypes.bool,
  meta: PropTypes.bool,
  monochrome: PropTypes.bool,
};

ChannelIcon.defaultProps = {
  className: null,
  rounded: false,
  meta: false,
  monochrome: false,
};

export default ChannelIcon;
